// extracted by mini-css-extract-plugin
module.exports = {"playerWrapper":"MediaPlayer_playerWrapper__MtW2v","video":"MediaPlayer_video__YXPgl","audio":"MediaPlayer_audio__BpflT"};